import { AxiosResponse } from 'axios';
import client from '../client';
import { ExcelDownloadSummary } from 'src/admin-entity/interface/excel/excel-download-summary.interface';

const removeUnusedParam = (url: string): string => {
    const newURL = new URL(url);
    newURL.searchParams.delete('productNames');
    newURL.searchParams.delete('categoryName');
    newURL.searchParams.delete('distributorName');
    return newURL.toString();
};

export const getStatistics = (url: string): Promise<AxiosResponse<any>> => {
    return client.get(removeUnusedParam(url));
};

export const getStatisticsExcel = (url: string): Promise<AxiosResponse<ExcelDownloadSummary>> => {
    return client.post(removeUnusedParam(url));
};

export const getUserDataExcel = (url: string, ids: any[]): Promise<AxiosResponse<ExcelDownloadSummary>> => {
    return client.post(removeUnusedParam(url), {
        ids,
    });
};
